import { render, staticRenderFns } from "./PxAutocompleteTags.vue?vue&type=template&id=9b11f6b0"
import script from "./PxAutocompleteTags.vue?vue&type=script&lang=js"
export * from "./PxAutocompleteTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports